export const DocumentDownload = {
  "documentName": "",
  "documentType": "",
  "Action": "",
  "ProductCategory": "",
  "ProductName": "",
  "pageName": "",
  "pageUrl": "",
  "pageCategory": "",
};